export default "__VITE_ASSET__6bce6f46__"